
import moment from 'moment';
import CryptoJS from "crypto-js";

const FuncionesAyuda = (function () {

    function getTextoLimpioMayus(texto){
        return texto.trim().toLowerCase().toUpperCase();
    }

    function getTextoLimpioMinus(texto){
        return texto.trim().toLowerCase();
    }

    function getFecha(fecha){   
        const nuevaFecha = moment(fecha).format("YYYY-MM-DD");
        return moment(nuevaFecha).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    }

    function getHora(hora){   
        return moment(hora).format("HH:mm:ss");
    }

    function getFechaHora(fecha, hora){
        const nuevaFecha = moment(fecha).format("YYYY-MM-DD");
        const nuevaHora = moment(nuevaFecha + " " + hora);
        return moment(nuevaHora).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    }

    function getFechaActual(){
        return moment(new Date()).utc().format("YYYY-MM-DD");
    }

    function getFechaHoraActual(){
        return moment(new Date()).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    }

    function getFechaLocal(fecha){
        let date = new Date(fecha);
        let options = {
          year: "numeric",
          month: "long",
          day: "numeric",
        };
        return date.toLocaleDateString("es-MX", options);
    }

    function getFechaHoraLocal(fecha){
        let date = new Date(fecha);
        let options = {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: "true",
        };
        return date.toLocaleDateString("es-MX", options);
    }

    function groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }
    function msi() {
        return [ 1, 3, 6, 9, 12, 15, 18,24, 36];
    }

    function encriptar(dato) {
        let encriptado
        if (process.env.VUE_APP_SECURE_API !== undefined &&
            (process.env.VUE_APP_SECURE_API === true || process.env.VUE_APP_SECURE_API === 'true')) {

            var keyForCryptoJS = CryptoJS.enc.Base64.parse(btoa(process.env.VUE_APP_SECURE_KEY_API));

            encriptado = CryptoJS.AES.encrypt(JSON.stringify(dato), keyForCryptoJS, {
                mode: CryptoJS.mode.ECB
            }).toString();
        }

        return encriptado;
    }

    function desencriptar(dato) {
        let desencriptado;
        const keyForCryptoJS = CryptoJS.enc.Base64.parse(btoa(process.env.VUE_APP_SECURE_KEY_API));
        const decodeBase64 = CryptoJS.enc.Base64.parse(dato);

        desencriptado = CryptoJS.AES.decrypt({ciphertext:decodeBase64}, keyForCryptoJS,
            {
                mode: CryptoJS.mode.ECB
            }
        ).toString(CryptoJS.enc.Utf8);

        return desencriptado;
    }

    return{
        limpiarTextoMayus: getTextoLimpioMayus,
        limpiarTextoMinus: getTextoLimpioMinus,
        traerFecha: getFecha,
        traerFechaHora: getFechaHora,
        traerFechaActual: getFechaActual,
        traerFechaHoraActual: getFechaHoraActual,
        traerFechaLocal: getFechaLocal,
        traerFechaHoraLocal: getFechaHoraLocal,
        traerHora: getHora,
        groupBy: groupBy,
        msi: msi,
        encriptar: encriptar,
        desencriptar: desencriptar,
     }
})();
export default FuncionesAyuda;
